











































































































































































import { Component, Inject, Vue } from "vue-property-decorator";
import { IStoreService } from "@/services/IStoreService";
import { IAuthService } from "frontend-core";
import { container } from "@/services/registerServiceProvider";
import Profile from "@/components/Profile.vue";
import AddAgentModal from "@/components/AddAgentModal.vue";
import { IUserRoleService } from "@/services/IUserRoleService";
import AgentAvatar from "@/components/AgentAvatar.vue";

type MenuItems = {
  icon: string;
  name: string;
  to: string | { name: string; params?: { agentId: string; page: number; } };
};

@Component({
  components: { AgentAvatar, AddAgentModal, Profile },
})
export default class HeaderCmpt extends Vue {
  drawer: boolean = false;
  @Inject() public readonly storeService!: IStoreService;
  private readonly roleService: IUserRoleService = container.resolve(
    "IUserRoleService",
  );

  get mobileMenuItemsTop(): any {
    const menuItems: MenuItems[] = [
      { icon: "fa-chart-line", name: "Главный раздел", to: "/" },
      {
        icon: "fa-search",
        name: "Поиск агентов",
        to: { name: "segmentation-search" },
      },
      { icon: "fa-users", name: "Дерево агентов", to: { name: "agents" } },
      { icon: "fa-question-circle", name: "Помощь", to: { name: "help" } },
    ];

    if (!this.isUserHasChangeParentRole) {
      const myAgentsBtn = { icon: "fa-table", name: "Мои агенты", to: { name: "curator-children", params: { agentId: this.storeService.currentAgent?.id || "", page: 1 } } };

      menuItems.splice(3, 0, myAgentsBtn);
    }

    return menuItems;
  }

  get isAllowAddNewAgents(): boolean {
    let res: boolean = false;

    if (this.storeService.currentAgent) {
      res =
        this.roleService.isUserSuperAdmin(
          this.storeService.currentAgent.user,
        ) ||
        this.roleService.isUserAdmin(this.storeService.currentAgent.user) ||
        this.roleService.isUserTechSupport(this.storeService.currentAgent.user);
    }

    return res;
  }

  get mobileMenuItemsBottom() {
    return [
      {
        icon: "fa-book-open",
        name: "Просмотр сегментации",
        to: {
          name: "segmentation-report",
          params: { agentId: this.storeService.currentAgent?.id || "" },
        },
        drawLink: this.roleService.isAllowSegmentationRead,
      },
      {
        icon: "fa-edit",
        name: "Изменение сегментации",
        to: {
          name: "segmentation-editor",
          params: { agentId: this.storeService.currentAgent?.id || "" },
        },
        drawLink: this.roleService.isAllowSegmentationEdit,
      },
    ];
  }

  get isUserHasChangeParentRole(): boolean {
    return (
      !!this.storeService.currentAgent && this.roleService.isHasChangeParentRole
    );
  }

  logout(): void {
    this.storeService.isManualLogout = true;
    this.storeService.currentPath = null;
    container.resolve<IAuthService>("IAuthService").logout();
  }

  back(): void {
    this.$router.back();
  }

  next(): void {
    this.$router.forward();
  }
}
